import { render, staticRenderFns } from "./testimonials_section.vue?vue&type=template&id=66d2582b&scoped=true"
import script from "./testimonials_section.vue?vue&type=script&lang=js"
export * from "./testimonials_section.vue?vue&type=script&lang=js"
import style0 from "./testimonials_section.vue?vue&type=style&index=0&id=66d2582b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d2582b",
  null
  
)

export default component.exports